import React from 'react';

const blogs = [
  { id: 1, img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e", title: "Far far away, behind the word mountains" },
  { id: 2, img: "https://images.unsplash.com/photo-1439066615861-d1af74d74000", title: "Far far away, behind the word mountains" },
  { id: 3, img: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1", title: "Far far away, behind the word mountains" }
];

export default function BlogPosts() {
  return (
    <section className="py-5" id="blog">
      <div className="container">
        <h6 className="text-uppercase fw-bold mb-5" style={{ color: '#1cc3b2', letterSpacing: '2px' }}>Blog Posts</h6>
        
        <div className="row g-4">
          {blogs.map((post) => (
            <div className="col-md-4" key={post.id}>
              <div className="card border-0 shadow-sm overflow-hidden">
                <div className="position-relative">
                  <img 
                    src={post.img} 
                    className="card-img-top" 
                    alt="blog" 
                    style={{ height: '240px', objectFit: 'cover' }} 
                  />
                  {/* The Cyan Circle Icon */}
                  <div 
                    className="position-absolute start-0 bottom-0 ms-4 shadow d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '45px', 
                      height: '45px', 
                      backgroundColor: '#1cc3b2', 
                      borderRadius: '50%', 
                      transform: 'translateY(50%)',
                      zIndex: 2 
                    }}
                  >
                    <i className="bi bi-pencil-fill text-white"></i>
                  </div>
                </div>
                
                <div className="card-body pt-5 px-4 pb-4">
                  <h5 className="fw-bold mb-4">{post.title}, far from the countries</h5>
                  <a href="#" className="text-decoration-none fw-bold" style={{ color: '#1cc3b2', fontSize: '12px' }}>
                    READ MORE
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}